<template>
  <div class="container-fluid">
    <div class="row pt-4">
      <div class="col-12 col-md-6 text-center mb-4">
        <a target="_blank"
           href="https://forms.office.com/Pages/ResponsePage.aspx?id=4XDVfhD6SEyRhMH0Dc8yYQBLqyxEASVFpDtDZuTVNJ5UN1pEU1A3NktZM0NBQjM5M05IQjIyUkRaRC4u"
           class="d-inline-block">
          <img src="../../assets/img/surveyOC.png"
               class="max-width-300px">
        </a>
        <br>
        <a target="_blank"
           href="https://forms.office.com/Pages/ResponsePage.aspx?id=4XDVfhD6SEyRhMH0Dc8yYQBLqyxEASVFpDtDZuTVNJ5UN1pEU1A3NktZM0NBQjM5M05IQjIyUkRaRC4u">
          Анкетна карта (OC)
        </a>
      </div>
      <div class="col-12 col-md-6 text-center mb-4">
        <a target="_blank"
           href="https://forms.office.com/Pages/ResponsePage.aspx?id=4XDVfhD6SEyRhMH0Dc8yYQBLqyxEASVFpDtDZuTVNJ5UNlk2S1VKWFgxVk1HTkxaMVlQVE9NNEpHTi4u"
           class="d-inline-block">
          <img src="../../assets/img/surveyNC.png"
               class="max-width-300px">
        </a>
        <br>
        <a target="_blank"
           href="https://forms.office.com/Pages/ResponsePage.aspx?id=4XDVfhD6SEyRhMH0Dc8yYQBLqyxEASVFpDtDZuTVNJ5UNlk2S1VKWFgxVk1HTkxaMVlQVE9NNEpHTi4u">
          Анкетна карта (NC)
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "survey-component"
}
</script>

<style scoped>

</style>
